import updateHomepageSettingsDriver from '../../../actions/siteadmin/updateHomepageSettingsDriver'

async function submit(values, dispatch) {
    await dispatch(updateHomepageSettingsDriver(values))
}

export default submit;